export default {
    captcha: {
        formProp: 'captcha',
        form: {
            label: 'Verification Code',
            required: true
        },
        field: {
            size: 'small',
            placeholder: 'Verification code...',
            value: ''
        },
        validation: [ 'alphanumeric', 'min-length:8' ]
    },
}
